import { render } from "./SourceData.vue?vue&type=template&id=4e393ab6&scoped=true"
import script from "./SourceData.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceData.vue?vue&type=script&setup=true&lang=js"

import "./SourceData.vue?vue&type=style&index=0&id=4e393ab6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e393ab6"],['__file',"src/pages/source/SourceData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e393ab6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e393ab6', __exports__)) {
    console.log('reload')
    api.reload('4e393ab6', __exports__)
  }
  
  module.hot.accept("./SourceData.vue?vue&type=template&id=4e393ab6&scoped=true", () => {
    console.log('re-render')
    api.rerender('4e393ab6', render)
  })

}


export default __exports__